// extracted by mini-css-extract-plugin
export default {"box":"orderFilterPage_box__QNTRv","box__content":"orderFilterPage_box__content__PYBwH"};